import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import useDocumentTitle from '../../hooks/useDocumentTitle';

function NotFound() {
    const { translate } = useLanguage();
    useDocumentTitle(translate('page_not_found'));

    return (
        <div className="homepage-content">
            <h1>{translate('page_not_found')}</h1>
            <div className="homepage-button-group">
                <Link to="/" className="homepage-action-button">
                    <span className="button-text">{translate('back_home')}</span>
                </Link>
            </div>
        </div>
    );
}

export default NotFound;
